import React, { Component } from 'react';
import { SubmitButton } from '../../';
import { stripWarningTags } from '../../ContentSection/UserGeneratedTextContainer';
import CloseIcon from '../../Common/CloseIcon';
import SuccessCheckmark from './SuccessCheckmark';
import './RequestReviewModal.scss';

export default class RequestReviewModal extends Component {
  state = {
    reviewRequestMessage: '',
    reviewRequestErrorMessage: '',
  };

  handleChange = e => {
    this.setState({ reviewRequestMessage: e.target.value });
  };

  handleRequest = e => {
    this.props.requestReviewUpdate(this.state.reviewRequestMessage);
  };

  render() {
    const {
      handleVisibilityToggle,
      userName,
      userEmail,
      reviewUpdateSuccessful,
      requestReviewResponseMessage,
      requestPending,
      isVisible,
    } = this.props;

    return (
      <aside
        className="RequestReviewModal bg-white gray pv3 pl4 pb4 pr4 pv4 w-90 fixed br1"
        style={{ display: isVisible === true ? 'block' : 'none' }}
      >
        <div className="relative pv2 ph3">
          <button
            onClick={handleVisibilityToggle}
            className="bg-transparent bn gray pointer absolute"
            style={{ right: '-15px', top: '-5px' }}
          >
            <CloseIcon style={{ width: '15px' }} />
          </button>

          {reviewUpdateSuccessful ? (
            <SuccessView
              handleVisibilityToggle={handleVisibilityToggle}
              userEmail={userEmail}
            />
          ) : (
            <React.Fragment>
              <RequestReviewFormHeader />
              <form name="request-review-update-form">
                <p className="f4">
                  Ask this reviewer to write an updated review on this product.
                  The new review will appear on your site with their original
                  review below it.
                </p>
                <address className="f4 dib fs-normal">
                  <span className="fw7 mid-gray">Sending to:</span>{' '}
                  {stripWarningTags(userName)} ({userEmail})
                </address>

                <label
                  htmlFor="request-text"
                  className="fw7 f4 mb0 db mt3 mid-gray"
                >
                  Remind the reviewer why you are asking for an updated review
                </label>
                <small>(Minimum 50 characters; maximum 2000)</small>
                {requestReviewResponseMessage &&
                  !reviewUpdateSuccessful && (
                    <ErrorMessage
                      errorText={prettifyMinimumLengthErrorIfExists(
                        requestReviewResponseMessage
                      )}
                    />
                  )}
                <textarea
                  id="request-text"
                  value={this.state.reviewRequestMessage}
                  onChange={this.handleChange}
                  className="w-100 mt3 mb4"
                  style={{ height: '150px', resize: 'none' }}
                  maxLength="1000"
                />
                <SubmitButton
                  label="Send Request"
                  className="f5 pa3"
                  style={{ minWidth: '93px' }}
                  onClick={this.handleRequest}
                  pending={requestPending}
                  disabled={requestPending}
                />

                <p>
                  <small className="gray">
                    *This request can only be made once. After you send this
                    request, the feature will no longer be available.
                  </small>
                </p>
              </form>
            </React.Fragment>
          )}
        </div>
      </aside>
    );
  }
}

const RequestReviewFormHeader = () => (
  <section className="flex items-center justify-between">
    <h1 className="mv0 mid-gray">Request Updated Review</h1>
  </section>
);

const SuccessView = ({ handleVisibilityToggle, userEmail }) => (
  <section className="tc mt5 pt4">
    <div>
      <SuccessCheckmark />
    </div>
    <h4 className="mid-gray">Your request has been sent.</h4>
    <p>The request was sent to {userEmail}.</p>
    <SubmitButton
      label="I'm Done"
      className="f4"
      style={{ minWidth: '130px', minHeight: '45px' }}
      onClick={handleVisibilityToggle}
    />
  </section>
);

const prettifyMinimumLengthErrorIfExists = errorText =>
  errorText.includes('minimum length')
    ? 'Your message is too short. Please enter a minimum of 50 characters.'
    : errorText;

const ErrorMessage = ({ errorText }) => (
  <p
    className="f4 mt2 dark-red mb0"
    style={{
      backgroundColor: '#f05e2442',
      color: '#dd3232',
      borderRadius: '2px',
      padding: '1em',
      fontSize: '12px',
    }}
  >
    {errorText}
  </p>
);



// WEBPACK FOOTER //
// ./src/components/ModerationCard/ClientModerationCard/RequestReviewModal.js